module.exports = __webpack_public_path__ + "img/Discoradio.6b61cfec.png";